<xproj-modal></xproj-modal>
<router-outlet>
</router-outlet>
